import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';

// antd 5 exposes no public tokens for the modal's padding or header divider.
export const Modal = styled(AntdModal)`
  .ant-modal-content {
    padding: unset;
  }

  .ant-modal-close-x {
    height: unset;
    width: unset;
  }

  .ant-modal-header {
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    padding: 16px 24px;
  }

  .ant-modal-body {
    padding: 24px;
  }

  .ant-modal-footer {
    padding: 10px 16px;
  }
`;
